import {useLocation} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useLocalStorage} from '../../../utils'
import {FormChangePassword} from './FormChangePassword'
import {Alerts} from '../../../components'

export function ChangePassword() {
  const [userRoot] = useLocalStorage<any>('persist:root', [])
  let location: any = useLocation()
  let email = location.state?.email
  const query = new URLSearchParams(location.search)
  let userId = query.get('userId')

  return (
    <>
      <Alerts />
      <a href='/' className='mb-12' style={{marginLeft: '95px'}}>
        <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-tmiv.png')} className='h-80px mb-5' />
      </a>
      <div className='text-center mb-8'>
        <h1 className='text-dark mb-3'>Đổi mật khẩu</h1>
      </div>
      <FormChangePassword userId={userId ? userId : userRoot?.userId?.replaceAll('"', '')} email={email} isEmailReset={userId ? true : false} />
    </>
  )
}
